module.exports = __webpack_public_path__ + "img/Deathknight-gnome-m-70.86857c31.gif";